import { useRef } from "react";
import "./App.css";
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemStatementSection from './components/ProblemStatementSection';
import FeaturedSpotlightSection from './components/FeaturedSpotlightSection';
import ProofReelSection from './components/ProofReelSection';
import WhoThisIsForSection from './components/WhoThisIsForSection';
import EducationSection from './components/EducationSection';
import WhatWeBuildSection from './components/WhatWeBuildSection';
import ProofLibrarySection from './components/ProofLibrarySection';
import TaborSection from './components/TaborSection';
import ProcessSection from './components/ProcessSection';
import CredibilitySection from './components/CredibilitySection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  const proofReelRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToProofReel = () => {
    proofReelRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App min-h-screen bg-[#040c14]">
      <Header />
      <Toaster position="top-right" theme="dark" />
      
      <main className="pt-20">
        <HeroSection 
          onWatchProof={scrollToProofReel}
          onBookCall={scrollToContact}
        />
        
        {/* Problem Statement - Lead with the problem */}
        <ProblemStatementSection />
        
        {/* Featured Spotlight - right after problem statement */}
        <div id="spotlight">
          <FeaturedSpotlightSection />
        </div>
        
        <div id="proof">
          <ProofReelSection ref={proofReelRef} />
        </div>
        
        {/* Who This Is For - Target Audience */}
        <WhoThisIsForSection />
        
        <div id="framework">
          <EducationSection />
        </div>
        
        <WhatWeBuildSection />
        
        <div id="library">
          <ProofLibrarySection />
        </div>
        
        {/* TABOR: A Christmas Tale Section */}
        <div id="tabor">
          <TaborSection />
        </div>
        
        <ProcessSection />
        
        {/* Credibility Section - Harry Mann Bio & Stats */}
        <CredibilitySection />
        
        {/* FAQ Section - SEO & AIO optimized */}
        <div id="faq">
          <FAQSection />
        </div>
        
        <div id="about">
          <AboutSection />
        </div>
        
        <div id="contact">
          <ContactSection ref={contactRef} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
